import React from "react";
import { ArrowRight } from "lucide-react";
import "./style.css";
import { Helmet } from "react-helmet-async";
import { Button } from "../ui/button"

const Hero = () => {
	const stats = [
		{ k: "React", v: "First", c: "primary" },
		{ k: "Hosting", v: "Included", c: "nebula" },
		{ k: "Support", v: "Ongoing", c: "plasma" },
		{ k: "Delivery", v: "On time", c: "aurora" },
	];

	return (
		<section id="home" className="hero">
			<Helmet>
				<title>Moonface Techs | Home</title>
				<meta name="description" content="Moonface Techs - Custom ReactJS Web Development Solutions" />
			</Helmet>
			<div className="grid-texture"></div>
			<div className="star-field"></div>

			<div className="glow glow-1"></div>
			<div className="glow glow-2"></div>
			<div className="glow glow-3"></div>
			<div className="glow glow-4"></div>

			<div className="hero-container">
				<div className="hero-grid">
					<div className="hero-content">
						<span className="label-mono">
							ReactJS Web Development Studio
						</span>

						<h1 className="hero-title">
							Moonface <span className="gradient-text">Techs</span>
						</h1>

						<p className="hero-subtitle">
							ReactJS Web Development Solutions for Your Business
						</p>

						<p className="hero-description">
							Leveraging the power of ReactJS with seamless hosting and reliable
							support. We specialize in creating stunning, high-performance
							websites that are tailored to your needs.
						</p>

						<div className="hero-buttons">
							<a href="/contact" rel="noreferrer">
							<Button className="btn btn-primary" style={{display: "flex", alignItems: "center", gap: "5px", backgroundColor: "#38bdf8", color: "black"}}>
								Get Free Quote
								<ArrowRight />
							</Button>
							</a>
							
							<a href="/portfolio" rel="noreferrer">
							<Button className="btn btn-outline">
								Learn More
							</Button>
							</a>
							
						</div>
					</div>

					<aside className="hero-sidebar">
						<div className="status-card">
							<p className="rule-mono">
								Status
								<span className="rule-line"></span>
							</p>

							<div className="status-row">
								<span className="status-dot"></span>

								<span className="status-text">
									Available for new projects
								</span>
							</div>

							<p className="status-description">
								Feel free to explore our packages. Nothing fits your needs?
								Let's discuss your projects.
							</p>

							<dl className="stats-grid">
								{stats.map((item) => (
									<div key={item.k}>
										<dt>{item.k}</dt>
										<dd className={item.c}>{item.v}</dd>
									</div>
								))}
							</dl>
						</div>
					</aside>
				</div>
			</div>
		</section>
	);
};

export default Hero;